import { __assign } from "tslib";
import * as React from 'react';
import s from './category-header-mobile.scss';
import { Text, Heading } from 'wix-style-react';
import { SubCategoriesSelectorMobile } from './sub-categories-selector-mobile';
import { composer } from '../../../component-decorators/composer';
import { BackButton } from '../../back-button';
export var CategoryHeaderMobile = composer()
    .withTranslation()
    .compose(function (_a) {
    var name = _a.name, description = _a.description, subCategoriesSelectorProps = _a.subCategoriesSelectorProps, shouldShowBackButton = _a.shouldShowBackButton;
    return (React.createElement("div", { "data-testid": 'category-header-mobile', className: s.categoryHeader },
        shouldShowBackButton && React.createElement(BackButton, { skinColor: 'light' }),
        React.createElement(Heading, { className: s.categoryHeaderName, appearance: 'H1', light: true, dataHook: 'category-header-mobile-name' }, name),
        React.createElement(Text, { size: 'medium', weight: 'normal', light: true, dataHook: 'category-header-mobile-description' }, description),
        React.createElement(SubCategoriesSelectorMobile, __assign({}, subCategoriesSelectorProps))));
});
//# sourceMappingURL=category-header-mobile.js.map